import { useEffect, useState } from 'react';
import { MOBILE_QUERY } from '../../utils/mobile';

/**
 * Czy ekran jest telefonem. Dla miejsc, gdzie wersja mobilna to inny UKŁAD, a nie tylko inne style
 * (np. karty zamiast tabeli) — samym CSS-em nie da się zamienić jednego drzewa komponentów na drugie.
 */
const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
